module.exports = __webpack_public_path__ + "img/r6.85dbd83b.jpg";